import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const orderRoutes: RouteRecordRaw[] = [
  {
    path: routes.MY_ORDERS,
    name: 'MY_ORDERS',
    component: () => import('./MyOrdersPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.ORDER_DETAIL,
    name: 'ORDER_DETAIL',
    component: () => import('./OrderDetailPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.ORDER_SUCCESS,
    name: 'ORDER_SUCCESS',
    component: () => import('./OrderSuccessPage.vue'),
    meta: { requiresAuth: true },
  },
]
